<template>
    <div id="footer">
        COPYRIGHT(C) RIGHTS RESREVED.
    </div>
</template>

<script>
</script>
